'use client'

import { Card, CardContent, CardHeader } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'

export const ShippingDetailsSkeleton = () => {
	return (
		<div className="bg-background min-h-screen">
			<div className="flex flex-col space-y-4 sm:space-y-6">
				{/* Header */}
				<div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
					<div className="flex items-center gap-4">
						<Skeleton className="h-10 w-10" />
						<div>
							<Skeleton className="mb-2 h-8 w-48" />
							<Skeleton className="h-4 w-64" />
						</div>
					</div>
					<div className="flex gap-2">
						<Skeleton className="h-10 w-24" />
						<Skeleton className="h-10 w-24" />
					</div>
				</div>

				{/* Form Cards */}
				<div className="mt-6 space-y-6">
					<Card>
						<CardHeader>
							<Skeleton className="h-6 w-32" />
						</CardHeader>
						<CardContent className="space-y-6">
							<div className="space-y-2">
								<Skeleton className="h-4 w-24" />
								<Skeleton className="h-10 w-full" />
							</div>
							<div className="space-y-2">
								<Skeleton className="h-4 w-24" />
								<Skeleton className="h-10 w-full" />
							</div>
						</CardContent>
					</Card>

					<Card>
						<CardHeader>
							<Skeleton className="h-6 w-32" />
						</CardHeader>
						<CardContent className="flex flex-col space-y-4">
							<div className="flex items-center space-x-2">
								<Skeleton className="h-6 w-6" />
								<Skeleton className="h-4 w-32" />
							</div>
							<div className="flex items-center space-x-2">
								<Skeleton className="h-6 w-6" />
								<Skeleton className="h-4 w-32" />
							</div>
						</CardContent>
					</Card>
				</div>
			</div>
		</div>
	)
}

